import { useUsersAutocomplete } from '~/api/queries/user'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import { formatName } from '~/utils/names'
import { chipValueMore } from '../FilterBar.css'

export const UsersChipValue = ({ value }: { value: string }) => {
  const { data } = useUsersAutocomplete({
    ids: [
      ...value
        .split(',')
        .map((v) => v.trim())
        .filter(Boolean)
    ]
  })
  const users = data?.pages[0]?.['hydra:member']
  const firstUser = users?.[0] ?? null
  const usersCount = data?.pages[0]?.['hydra:member']?.length || 0
  return firstUser ? (
    <Tooltip
      text={
        usersCount > 1 ? users?.map((u) => formatName(u)).join(', ') : undefined
      }
      direction="top"
    >
      {formatName(firstUser)}{' '}
      {usersCount > 1 && (
        <span className={chipValueMore}>+{usersCount - 1}</span>
      )}
    </Tooltip>
  ) : null
}
